import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { ApiStatus } from "../../utils/api.types";
import { ISupplierSliceState } from "../../utils/supplier.types";
import { fetchSuppliers, fetchSupplierById } from "../supplierStore/supplierThunk";

/**
 * Supplier slice initial state.
 */
const initialState: ISupplierSliceState = {
    suppliers: [],    
    rowCount: 0,
    errorMessage: '',
    supplierById: undefined,
    status: ApiStatus.IDLE
}

/**
 * Suppliers Slice.
 */
const supplierSlice = createSlice({
    name: 'supplier',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // Fetch suppliers
            .addCase(fetchSuppliers.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchSuppliers.fulfilled, (state, action:any) => {
                state.status = ApiStatus.SUCCESS;
                state.suppliers = action?.payload || [];
                state.rowCount = action?.payload.total || 0;
                state.errorMessage = '';
            })
            .addCase(fetchSuppliers.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Fetch Suppliers by userId
            .addCase(fetchSupplierById.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchSupplierById.fulfilled, (state, action:any) => {
                state.status = ApiStatus.SUCCESS;
                state.suppliers = action?.payload?.suppliers || undefined;
                state.errorMessage = '';
            })
            .addCase(fetchSupplierById.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })
    }
});

export default supplierSlice.reducer;
